/*
 * @Author: cc
 * @Date: 2019-12-08 19:24:26
 * @LastEditTime: 2021-09-30 16:01:17
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\app\preview\appPreview.js
 * @Description: app渠道查看页
 */
'use strict';
angular.module('appPreviewModule', []).controller('appPreviewCtrl', [
    '$scope',
    '$element',
    '$compile',
    '$sce',
    '$q',
    '$state',
    '$filter',
    'trsHttpService',
    '$stateParams',
    'editcenterRightsService',
    'modalDialog',
    'editingCenterService',
    'trsPrintService',
    'localStorageService',
    'newMediaService',
    'editingMediatype',
    function(
        $scope,
        $element,
        $compile,
        $sce,
        $q,
        $state,
        $filter,
        trsHttpService,
        $stateParams,
        editcenterRightsService,
        modalDialog,
        editingCenterService,
        trsPrintService,
        localStorageService,
        newMediaService,
        editingMediatype
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化页面参数
         * @return {[type]} [description]null
         */
        function initStatus() {
            $scope.params = {
                serviceid: 'mlf_appmetadata',
                methodname: 'getNewsDoc',
                ChnlDocId: $stateParams.appchnldocid,
                fromsearch: $stateParams.fromsearch
            };
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
            };
            $scope.videos = [];
            $scope.status = {
                picsModelShow: true,
                // 是否只是展示（比如稿件收藏），不需要请求权限、上一篇、下一篇等功能
                onlyPreview: $state.params.appchannelid === '0',
                // 显示操作栏
                // contentControllShow: typeof $state.params.appplatform !== 'undefined',
                btnRights: {},
                // 顶部按钮权限
                btnRightsName: ['app.daibian', 'app.daishen', 'app.yiqianfa', 'appsite.signtime', 'appsite.recyle'],
                // 判断从哪块进入
                platform: {
                    daibian: 0,
                    daishen: 1,
                    yiqianfa: 2,
                },
                fusionApp: !!$stateParams.iwometadataid, // 融合稿件
                listOpen: 1, // 1 基本信息 2 列表信息  3属性信息
                previewBigFace: {
                    status: false,
                }, // 查看痕迹
                editType: {
                    1: 'appnews',
                    2: 'appatlas',
                    3: 'appsubject',
                    4: 'appwebsite',
                    5: 'appactivity',
                    6: 'apptopic',
                    7: 'appvideo',
                    8: 'applive',
                    12: 'appaudio',
                    14: 'operationalActivity',
                    15: 'advertisement',
                },
                docTypeMap: {
                    1: '新闻稿',
                    2: '图集稿',
                    3: '专题稿',
                    4: '链接稿',
                    5: '活动稿',
                    6: '主题稿',
                    7: '视频稿',
                    8: '直播稿',
                    12: '音频稿',
                    13: '视频专辑',
                    14: '运营活动',
                    15: '广告',
                },
                // 初始化按钮
                initBtn: true,
                // 通过docType 来判断进入新闻还是图集
                methodname: {
                    1: 'getNewsDoc',
                    2: 'getPicsDoc',
                    3: 'getSpecialDoc',
                    4: 'getLinkDoc',
                    5: 'getActivityDoc',
                    6: 'getTopicDoc',
                    7: 'getVideoDoc',
                    8: 'getLiveDoc',
                    12: 'getAudioDoc',
                    13: 'getVideosDoc',
                    14: 'getNewsDoc',
                    15: 'getNewsDoc',
                },
                commentset: {
                    0: '关闭',
                    1: '先审后发',
                    2: '先发后审',
                },
                listStyle: {
                    0: '图文',
                    1: '多图',
                    2: '文字',
                },
                displayset: {
                    0: '取专题基本信息',
                    1: '取新闻列表信息',
                },
                listpicsLen: {
                    0: 1,
                    1: 3,
                    2: 0,
                },
                thumb: {
                    0: '不允许',
                    1: '允许',
                },
                pubList: {
                    0: '不公布',
                    1: '公布',
                },
                liveStatus: {
                    1: '直播',
                    2: '回顾',
                },
                liveLable: {
                    1: '视频直播',
                    2: '图文直播',
                },
                docType: $stateParams.appdoctype,
                propertyOpen: false,
                // 关键字选中
                kwselected: false,
                // 相关专栏 按钮选中
                relatedArr: [true, false, false],
                authorInfo: true,
                fusionType: !!$stateParams.iwometadataid, // 融合稿 true
                isCollectDraft: $stateParams.iwomodalname === 'iwo.collect',
                isawaitrevise: !!$state.params.isawaitrevise, // 是否是待修订稿件
                groupNewsPage: {
                    CURRPAGE: 1,
                    PAGESIZE: 100000,
                    ITEMCOUNT: 0,
                    PAGECOUNT: 0,
                },
            };
            $scope.data = {
                item: [],
                groups: [],
                copyVersion: [],
                groupDraft: [],
                keywords: [],
                fusionRouter: {
                    // 融合编辑器路由
                    '1': 'fusionnews',
                    '2': 'fusionatlas',
                    '4': 'fusionlinkdoc',
                    '5': 'fusionactivity',
                    '6': 'fusiontopic',
                    '7': 'fusionvideo',
                    '8': 'fusionlive',
                    '12': 'fusionvideo',
                }
            };
            getUeditorCss();
        }

        /**
         * [getDraftStage description] 获取当前稿件在哪个审核阶段（去除需要传入的wzplatform的情况，主要是从IM来的稿件）
         * @return  {[type]}  [return description]
         */
        function getDraftStage(){
            editingCenterService.getDraftStage($scope.data.item, {
                mediatype: editingMediatype.app,
                metadataid: $state.params.appmetadataid
            }).then((data) => {
                $state.params.appplatform = data;
                $scope.status.contentControllShow = typeof $state.params.appplatform !== 'undefined';
                dealRight();
            });
        }

        /**
         * [dealRight description]处理权限
         * @return  {[type]}  [return description]
         */
        function dealRight() {
            if ($scope.status.onlyPreview) {
                return;
            }
            if (!!$stateParams.iwometadataid) {
                if (!$stateParams.departmentDocId) {
                    editcenterRightsService.initIwoListBtn($stateParams.iwomodalname).then(function(data) {
                        $scope.status.btnRights = data;
                    });
                } else {
                    getDepartDocAuthority();
                }
                // 获取查看痕迹按钮权限
                editcenterRightsService.initIwoListBtn('iwo.trace').then(function(data) {
                    $scope.status.bigFaceRights = !!data['iwo.trace.chakan'] ? 'true' : 'false';
                });
                $scope.status.docType = $stateParams.appdoctype; // app 融合稿 type减一
            } else {
                // 获取查看痕迹按钮权限
                editcenterRightsService.initWebsiteListBtnWithoutChn('appsite.trace', $stateParams.appsiteid).then(function(data) {
                    $scope.status.bigFaceRights = !!data['appsite.trace.chakan'] ? 'true' : 'false';
                });
            }
            if (!$stateParams.iwometadataid && typeof $state.params.appplatform !== 'undefined') {
                if ($state.params.appplatform > 2) {
                    editcenterRightsService
                        .initAppListBtnWithoutChn($scope.status.btnRightsName[$state.params.appplatform], $stateParams.appsiteid)
                        .then(function(rights) {
                            $scope.status.btnRights = rights;
                        });
                } else {
                    editcenterRightsService
                        .initAppListBtn($scope.status.btnRightsName[$state.params.appplatform], $stateParams.appchannelid)
                        .then(function(rights) {
                            $scope.status.btnRights = rights;
                        });
                }
            }
        }

        /**
         * [getDepartDocAuthority description]部门稿库权限
         * @return  {[type]}  [return description]
         */
        function getDepartDocAuthority() {
            var params = {
                serviceid: 'mlf_metadataright',
                methodname: 'queryOperkeyOfDeptmentalDoc',
                DepartmentalDocId: $stateParams.departmentDocId,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                for (var i = 0; i < data.length; i++) {
                    $scope.status.btnRights[data[i]] = true;
                }
            });
        }

        /**
         * [loadDirective description]动态加载指令
         * @return {[type]} [description]
         */
        function loadDirective() {
            var htmlContent = '<div adjustsize class="padding20" trs-play-audio-video  ng-bind-html="data.item.HTMLCONTENT|trsSceHtmlContent">';
            var videoContent = '<div trs-upload-for-xj-video-draft list="data.item" preview="true"></div>';
            newMediaService.previewLoadDirective($element, $compile, $scope, htmlContent, videoContent);
        }

        /**
         * [handleDocSourceName description] 处理稿件来源数据
         * @return {[type]} [description]
         */
        $scope.handleNewsSourceName = function() {
            return typeof $scope.data.item.NEWSSOURCES === 'object' ? $scope.data.item.NEWSSOURCES.SRCNAME : $scope.data.item.NEWSSOURCES;
        };

        /**
         * [getUeditorCss description] 加载编辑器中的相关样式
         * @return {[type]} [description]
         */
        function getUeditorCss() {
            $('.lazyload').remove();
            LazyLoad.css('./lib/ueditor2/themes/iframe.css');
        }

        /**
         * [getVersion description]获得操作日志
         * @param   {[type]}  id  [id description]
         * @return  {[type]}      [return description]
         */
        function getVersion(id) {
            var defer = $q.defer();
            var metadataid = id ? id : $stateParams.appmetadataid;
            metadataid = $stateParams.iwometadataid ? $stateParams.iwometadataid : metadataid;
            editingCenterService.getEditVersionTime(metadataid, $scope.page, $scope.data.copyVersion).then(
                function(data) {
                    $scope.data.version = data;
                    $scope.page = data.page;
                    $scope.data.copyVersion = data.copyArray;
                    defer.resolve();
                },
                function() {
                    defer.resolve();
                }
            );
            return defer.promise;
        }

        /**
         * [getLoadMore description] 操作日志点击加载更多
         * @return {[type]} [description]
         */
        $scope.getLoadMore = function() {
            $scope.page.CURRPAGE++;
            getVersion();
        };

        /**
         * [initData description]初始化页面数据
         * @return {[type]} [description]
         */
        function initData() {
            $scope.params.methodname = $scope.status.methodname[$scope.status.docType];
            requestData().then(function(data) {
                if ($scope.status.docType == 13) {
                    $scope.data.VIDEOREL = data.VIDEOREL.map((item, index) => ({
                        AUDIOVIDEOID: item.AUDIOVIDEOID,
                        FILENAME: item.REMARKS,
                        REMARKS: item.REMARKS,
                        FILESIZE: item.FILESIZE,
                        SRC: $sce.trustAsResourceUrl(item.URL),
                        COMMENTS: item.COMMENTS,
                        DURATION: formatTime(item.DURATION),
                    }));
                }
                getDraftStage();
                getVersion();
                loadDirective();
                loadVersionTimePanel();
            });
        }

        /**
         * [formatTime description] 将秒转化为时分秒
         * @param  {[type]} val [description]
         * @return {[type]} [description]
         */
        function formatTime(val) {
            var s = parseInt(val),
                m = 0,
                h = 0;
            if (!s) {
                return '';
            }
            if (s > 60) {
                m = parseInt(s / 60);
                s = parseInt(s % 60);
                if (m > 60) {
                    h = parseInt(m / 60);
                    m = parseInt(m % 60);
                    if (h > 60) {
                        h = parseInt(h % 60);
                    }
                }
            }
            var result = parseInt(s);
            result = result < 10 ? '0' + result : result;
            if (m > 0) {
                m = parseInt(m) < 10 ? '0' + m : m;
                result = '' + m + ':' + result;
            }
            if (h > 0) {
                h = parseInt(h) < 10 ? '0' + h : h;
                result = '' + h + ':' + result;
            }
            return result;
        }

        /**
         * [requestData description]数据请求函数
         * @return {[type]} [description]
         */
        function requestData() {
            var deferred = $q.defer();
            if (!!$stateParams.iwometadataid) {
                $scope.params = {
                    serviceid: 'mlf_fusioncreate',
                    methodname: 'getAPPFusionDoc',
                    sourceDocId: $stateParams.iwometadataid,
                };
            }
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
                $scope.data.item = data;
                document.title = data.TITLE;
                if ($scope.status.docType == 1 || $scope.status.docType == 2) {
                    $scope.data.item.fgdAuthor = ''; // 供稿作者
                    for (var i = 0; i < data.FGD_AUTHINFO.length; i++) {
                        $scope.data.item.fgdAuthor += data.FGD_AUTHINFO[i].USERNAME + ',';
                    }
                    $scope.data.item.fgdAuthor = $scope.data.item.fgdAuthor.substring(0, $scope.data.item.fgdAuthor.length - 1);
                }
                if ($scope.status.docType == 13) {
                    $scope.data.item.LISTPICS = data.LISTPICS.split(',');
                }
                // 关键字
                spiltKeyword();
                if (!$stateParams.iwometadataid) {
                    editingCenterService.queryVerifyDoc($scope.data.item);
                    if ($scope.status.docType == 3) {
                        // 专题稿
                        if (angular.isDefined(data.FZ_SPECIALGROUPINFO)) {
                            $scope.data.groups = data.FZ_SPECIALGROUPINFO;
                        }
                    }
                }
                if (!!$stateParams.iwometadataid && !!$scope.list) {
                    $scope.data.item.ISNOPAYMENT = $scope.list.ISNOPAYMENT;
                    $scope.data.item.FGD_AUTHINFO = $scope.list.FGD_AUTHINFO;
                    $scope.data.item.FGD_EDITINFO = $scope.list.FGD_EDITINFO;
                    $scope.data.item.NEWSSOURCES = $scope.list.DOCSOURCENAME;
                }
                deferred.resolve(data);
            });
            return deferred.promise;
        }

        /**
         * [spiltKeyword description] 切割关键字
         * @return {[type]} [description]
         */
        function spiltKeyword() {
            if ($scope.data.item.KEYWORDS) {
                $scope.data.keywords = $scope.data.item.KEYWORDS.split(';');
            }
        }

        /**
         * [fusionGostate description] 融合采编预览页跳转
         *
         * @param   {[type]}  doctype         [doctype description]
         * @param   {[type]}  iwometadataid   [iwometadataid description]
         * @param   {[type]}  iwochnldocid    [iwochnldocid description]
         * @param   {[type]}  mlftype         [mlftype description]
         * @param   {[type]}  collectid       [collectid description]
         * @param   {[type]}  departdocrelid  [departdocrelid description]
         *
         * @return  {[type]}                  [return description]
         */
        function fusionGostate(doctype, iwometadataid, iwochnldocid, mlftype, collectid, departdocrelid) {
            mlftype = !mlftype ? '' : mlftype;
            collectid = !collectid ? '' : collectid;
            var routerParams = {
                iwotype: doctype,
                iwomodalname: $stateParams.iwomodalname,
                wzplatform: 0,
                wztypeid: doctype,
                appplatform: 0,
                newspapertype: 2,
                iwometadataid: iwometadataid,
                iwochnldocid: iwochnldocid,
                mlftype: mlftype, // 是否来自资源中心
                iwodoccollectrelid: collectid,
                departdocrelid: departdocrelid,
            };
            routerParams.appdoctype = doctype;
            if (mlftype == 0 || !mlftype) {
                getBindingMediaIds(iwometadataid).then(function(bingdingData) {
                    angular.forEach(bingdingData, function(value, key) {
                        if (value.MEDIATYPE == '1') {
                            routerParams.appsiteid = value.SITEID;
                            routerParams.appchannelid = value.CHANNELID;
                            routerParams.appchnldocid = value.CHNLDOCID;
                            routerParams.appmetadataid = value.VIRTUALDOCID;
                        } else if (value.MEDIATYPE == '2') {
                            routerParams.wzsiteid = value.SITEID;
                            routerParams.wzchannelid = value.CHANNELID;
                            routerParams.wzchnldocid = value.CHNLDOCID;
                            routerParams.wzmetadataid = value.VIRTUALDOCID;
                        } else if (value.MEDIATYPE == '3') {
                            routerParams.paperid = value.CHANNELID; // 预览页与编辑页参数不同
                            routerParams.bzmetadata = value.VIRTUALDOCID; // 预览页与编辑页参数不同
                        }
                    });
                    $state.go($state.current.name, routerParams, {
                        reload: true
                    }); // new
                });
            } else {
                $state.go($state.current.name, routerParams, {
                    reload: true
                }); // new
            }
        }

        /**
         * [getBindingMediaIds description] 获取绑定的渠道的相关id
         * @param {[type]} [iwometadataid] [description] iwo稿件id
         * @return {[type]} [description]
         */
        function getBindingMediaIds(iwometadataid) {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_fusioncreate',
                methodname: 'queryFuseMappings',
                sourceDocId: iwometadataid,
                mediaTypes: '',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                defer.resolve(data);
            });
            return defer.promise;
        }

        /**
         * [creationAxis description] 创作轴
         * @return {[type]} [description]
         */
        $scope.creationAxis = function() {
            var params = {
                serviceid: 'mlf_releasesource',
                methodname: 'addPersonalMaterialOfTxt',
                PersonalMaterialId: 0,
                metadataid: $stateParams.appmetadataid,
                MediaType: '1',
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                modalDialog.alertType('添加成功', '', 'success', false);
            });
        };

        /**
         * [printBtn description] 打印
         *
         * @return  {[type]}  [return description]
         */
        $scope.printBtn = function() {
            requestPrintVersion($stateParams.appmetadataid).then(function(data) {
                requestPrintData(data);
            });
        };

        /**
         * [requestPrintVersion description] 打印请求流程
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        function requestPrintVersion(item) {
            var deferred = $q.defer();
            trsHttpService
                .httpServer(trsHttpService.getWCMRootUrl(), { serviceid: 'mlf_metadatalog', methodname: 'query', MetaDataId: item }, 'get')
                .then(function(data) {
                    deferred.resolve(data.DATA);
                });
            return deferred.promise;
        }

        /**
         * [requestPrintData description] 打印请求详情
         * @param   {[type]}  version  [version description]
         * @return  {[type]}           [return description]
         */
        function requestPrintData(version) {
            var params = {
                serviceid: 'mlf_appmetadata',
                methodname: $scope.status.methodname[$scope.status.docType],
                ChnlDocId: $stateParams.appchnldocid,
            };
            $scope.data.printResult = [];
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                var result = data;
                data.VERSION = version;
                data.HANGCOUNT = Math.ceil(data.DOCWORDSCOUNT / 27);
                $scope.data.printResult.push(result);
                trsPrintService.trsAppPrintDocument($scope.data.printResult);
            });
        }

        /**
         * [bigFace description] 大花脸
         * @return {[type]} [description]
         */
        $scope.bigFace = function() {
            if ($scope.data.item.DOCTYPEID === '2' || $scope.data.item.DOCTYPEID === '7') {
                $scope.status.picsModelShow = !$scope.status.picsModelShow;
            }
            $scope.status.previewBigFace.status = !$scope.status.previewBigFace.status;
        };


        /**
         * [getGroupDraft description] 获取指定分组下的新闻
         * @param  {[type]} group [description]
         * @return {[type]}       [description]
         */
        $scope.getGroupDraft = function(group) {
            var params = {
                serviceid: 'mlf_specialgroup',
                methodname: 'querySpecialGroupNewsFromGroup',
                SpecialGroupID: group.SPECIALGROUPID,
                CurrPage: $scope.status.groupNewsPage.CURRPAGE,
                PageSize: $scope.status.groupNewsPage.PAGESIZE,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.groupDraft[group.SPECIALGROUPID] = data instanceof Object ? data.DATA : data;
                $scope.data.groupDraft[group.SPECIALGROUPID] = $filter('unique')($scope.data.groupDraft[group.SPECIALGROUPID], 'NEWSSPECIALDATAID');
                angular.forEach($scope.data.groupDraft[group.SPECIALGROUPID], function(data, index) {
                    data.METADATAID = data.SPECIALGROUPID;
                    data.LISTTITLE = data.DOCTITLE;
                });
            });
        };

        /**
         * [pageTurning description] 翻页 上一篇/下一篇
         * @param {int} direction [description]
         * @return {[type]} [description]
         */
        $scope.pageTurning = function(direction) {
            var pageTurningData;
            var metadataid;
            if (!!$stateParams.iwometadataid) {
                pageTurningData = JSON.parse(localStorageService.get('fusionPreview'));
                metadataid = $stateParams.iwometadataid;
            } else {
                pageTurningData = JSON.parse(localStorageService.get('appPreview'));
                metadataid = $stateParams.appmetadataid;
            }
            var toPageData;
            for (var i = 0; i < pageTurningData.length; i++) {
                if (
                    pageTurningData[i].METADATAID === metadataid ||
                    pageTurningData[i].MLFID === metadataid ||
                    pageTurningData[i].DOCID === metadataid
                ) {
                    toPageData = pageTurningData[i + direction];
                    break;
                }
            }
            if (!toPageData) {
                var directionTxt = direction === 1 ? '下' : '上';
                modalDialog.alertType('没有' + directionTxt + '一篇了！', '', 'warning', false);
                return;
            }
            if (!!$stateParams.iwometadataid) {
                if ($stateParams.iwomodalname === 'iwo.collect') {
                    fusionGostate(toPageData.DOCTYPEID, toPageData.MLFID, toPageData.CHNLDOCID, toPageData.MLFTYPE, toPageData.DOCCOLLECTRELID);
                } else if ($stateParams.iwomodalname === 'iwo.waste') {
                    fusionGostate(toPageData.DOCTYPE, toPageData.DOCID, toPageData.CHNLDOCID); // /app
                } else {
                    fusionGostate(toPageData.DOCTYPEID, toPageData.METADATAID, toPageData.CHNLDOCID, '', '', toPageData.DEPARTDOCRELID);
                }
            } else {
                $state.go($state.current.name, {
                    appchnldocid: toPageData.CHNLDOCID,
                    appmetadataid: toPageData.METADATAID,
                    appdoctype: toPageData.DOCTYPEID,
                    appsiteid: $stateParams.appsiteid,
                    appplatform: $state.params.appplatform,
                }, {
                    reload: true
                });
            }
        };

        /**
         * [goToEdit description]
         * @return  {[type]}  [return description]
         */
        $scope.goToEdit = function() {
            var urlParams = {
                appplatform: $state.params.appplatform,
                mediaType: '1'
            };
            editingCenterService.routerToEditorWithLock(angular.extend($scope.data.item, urlParams));
        };

        /**
         * [loadVersionTimePanel 动态加载流程版本信息]
         *
         * @return  {[type]}  [return description]
         */
        function loadVersionTimePanel() {
            var versionPanel =
                '<version-time-panel incoming-data="data.item"></version-time-panel>';
            versionPanel = $compile(versionPanel)($scope);
            $element.find('versionPanel').append(versionPanel);
        }
    },
]);
